"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OptionElement = void 0;
const react_1 = __importDefault(require("react"));
const OptionElement = (_a) => {
    var { isItemValid: _ } = _a, htmlProps = __rest(_a, ["isItemValid"]);
    return (react_1.default.createElement("option", Object.assign({}, htmlProps), htmlProps.children));
};
exports.OptionElement = OptionElement;
//# sourceMappingURL=option-element.js.map